import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ProjectImageData } from "../../shared/interfaces/project-image-data.interface";
import { ProjectService } from "../../shared/services/project.service";
import { AlertService } from "../../../shared/alert/shared/alert.service";
import { AlertTypes } from "../../../shared/alert/shared/alert-types";
import { environment } from "../../../../environments/environment";

@Component({
  selector: 'avs-set-image-modal',
  templateUrl: './set-image-modal.component.html',
  styleUrls: ['./set-image-modal.component.css']
})
export class SetImageModalComponent {
  protected readonly environment = environment;

  constructor(
    private dialogRef: MatDialogRef<SetImageModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProjectImageData,
    private projectService: ProjectService,
    private alertService: AlertService) {}

  public onCloseModalClicked(): void {
    this.dialogRef.close();
  }

  public onDeleteImageClicked(): void {
    this.projectService.deleteImageForRouteStation(this.data.projectRouteStationImageId).subscribe(() => {
      this.alertService.alert('Das Bild wurde aus der Station entfernt', AlertTypes.info);
      this.dialogRef.close(true);
    });
  }
}
